var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "2e0d5120-7eab-41e7-a906-b04a6b9c3059",
    "data-name": "New VF Icon AW",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100mm",
    height: "100mm",
    viewBox: "0 0 283.5 283.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VF_Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M216.6,28.8c-25.8,5.4-46.3,29.4-46.2,56.6a14.8,14.8,0,0,0,.2,2.3c43.2,10.5,62.7,36.6,62.9,72.6s-28.3,75.5-76.4,75.7c-38.9.1-79.5-33.1-79.6-86.5-.1-35.3,18.9-69.3,43.3-89.4s56.3-32.3,85.8-32.4a35.9,35.9,0,0,1,10.2,1.1,141.7,141.7,0,1,0,81.1,128.1A141.2,141.2,0,0,0,216.6,28.8Z",
    transform: "translate(-14.2 -15.2)",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.5dff347f8636e7919a7dce7df5784f2f.svg";
export { ForwardRef as ReactComponent };